/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentWalletCardBillingDetailsApiModel } from './payment-wallet-card-billing-details';

/**
 * Wallet Caerd Info
 */
export interface PaymentWalletCardsApiModel {
  /**
   * Card alias (optional)
   */
  alias?: string;
  billing_details?: PaymentWalletCardBillingDetailsApiModel;
  /**
   * Card brand (optional)
   */
  brand?: string;
  /**
   * Card is default
   */
  default?: boolean;
  /**
   * Card external id (optional)
   */
  external_id?: string;
  /**
   * Card funding type (optional)
   */
  funding?: string;
  /**
   * Card Id
   */
  id?: string;
  integration_types?: Array<PaymentWalletCardsApiModelIntegrationTypesEnum>;
  /**
   * Card corporate flag (optional)
   */
  is_corporate?: number;
  /**
   * Card expired flag (optional)
   */
  is_expired?: number;
  /**
   * Card masked PAN
   */
  mask?: string;
  /**
   * Password required for using
   */
  password?: boolean;
  /**
   * Card payment type (optional)
   */
  payment_type?: PaymentWalletCardsApiModelPaymentTypeEnum;
}
export enum PaymentWalletCardsApiModelIntegrationTypesEnum {
  Checkout = 'checkout',
  Elements = 'elements'
}
export enum PaymentWalletCardsApiModelPaymentTypeEnum {
  Card = 'card'
}
